export enum AsyncActionStatus {
  idle,
  running,
  success,
  error,
}

export interface AsyncActionState<T> {
  status: AsyncActionStatus;
  error: string | null;
  result: T | null;
}
